import { Users, ShieldCheck, AlertTriangle, TrendingUp } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useIsMobile } from "@/hooks/use-mobile";

const KeyMetrics = () => {
  const isMobile = useIsMobile();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      <Card className="p-4 md:p-6 hover:shadow-lg transition-all duration-200 bg-gradient-to-br from-blue-50 to-white">
        <div className="flex flex-col items-center text-center">
          <div className="p-2 md:p-3 bg-blue-100 rounded-full mb-4">
            <Users className="h-5 w-5 md:h-6 md:w-6 text-blue-600" />
          </div>
          <div className="space-y-1">
            <p className="text-xs md:text-sm font-medium text-muted-foreground">Total Users</p>
            <h3 className="text-xl md:text-2xl font-bold">1,245</h3>
            <p className="text-xs md:text-sm text-green-600">+12.5% this month</p>
          </div>
        </div>
      </Card>
      
      <Card className="p-4 md:p-6 hover:shadow-lg transition-all duration-200 bg-gradient-to-br from-green-50 to-white">
        <div className="flex flex-col items-center text-center">
          <div className="p-2 md:p-3 bg-green-100 rounded-full mb-4">
            <ShieldCheck className="h-5 w-5 md:h-6 md:w-6 text-green-600" />
          </div>
          <div className="space-y-1">
            <p className="text-xs md:text-sm font-medium text-muted-foreground">Verified Users</p>
            <h3 className="text-xl md:text-2xl font-bold">892</h3>
            <div className="flex flex-col items-center mt-1">
              <div className="w-full bg-gray-200 rounded-full h-1.5">
                <div className="bg-green-600 h-1.5 rounded-full" style={{ width: "72%" }}></div>
              </div>
              <span className="text-xs text-green-600 mt-1">72%</span>
            </div>
          </div>
        </div>
      </Card>
      
      <Card className="p-4 md:p-6 hover:shadow-lg transition-all duration-200 bg-gradient-to-br from-yellow-50 to-white">
        <div className="flex flex-col items-center text-center">
          <div className="p-2 md:p-3 bg-yellow-100 rounded-full mb-4">
            <AlertTriangle className="h-5 w-5 md:h-6 md:w-6 text-yellow-600" />
          </div>
          <div className="space-y-1">
            <p className="text-xs md:text-sm font-medium text-muted-foreground">Pending Reviews</p>
            <h3 className="text-xl md:text-2xl font-bold">23</h3>
            <div className="flex items-center justify-center space-x-2 mt-1">
              <span className="text-xs text-yellow-600">4 urgent</span>
            </div>
          </div>
        </div>
      </Card>
      
      <Card className="p-4 md:p-6 hover:shadow-lg transition-all duration-200 bg-gradient-to-br from-purple-50 to-white">
        <div className="flex flex-col items-center text-center">
          <div className="p-2 md:p-3 bg-purple-100 rounded-full mb-4">
            <TrendingUp className="h-5 w-5 md:h-6 md:w-6 text-purple-600" />
          </div>
          <div className="space-y-1">
            <p className="text-xs md:text-sm font-medium text-muted-foreground">Growth Rate</p>
            <h3 className="text-xl md:text-2xl font-bold">+12.5%</h3>
            <p className="text-xs md:text-sm text-purple-600">vs last month</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default KeyMetrics;